// extracted by mini-css-extract-plugin
export default {"header-svg-icon-container":"svg-icon-module--header-svg-icon-container--4ace2","headerSvgIconContainer":"svg-icon-module--header-svg-icon-container--4ace2"};